"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m4.093 15.31-2.122-2.122.708-.707L4.3 14.102V0h1v14.102l1.621-1.621.707.708-2.121 2.12-.69.691h-.033l-.69-.69ZM8.371 2.822 10.706.486 11.191 0h.016l.699.699 2.121 2.122-.707.706-1.62-1.621V16h-1V1.907L9.08 3.528l-.708-.706Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m16.5 0-3.713 3.712.796.796 2.354-2.355V24h1.125V2.157l2.355 2.355.796-.795-2.92-2.92.002-.002L16.5 0ZM6.938.006V21.85l-2.355-2.355-.795.796 2.92 2.919-.003.002.789.79h.013l3.706-3.707-.795-.795-2.355 2.355V.006H6.938Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m22 0-4.95 4.95 1.06 1.06 3.14-3.14V32h1.5V2.876l3.14 3.14 1.06-1.06-3.893-3.894.002-.002L22 0ZM9.25.008v29.125l-3.14-3.14-1.06 1.061 3.892 3.892-.002.002L9.992 32h.018l4.94-4.94L13.89 26l-3.14 3.138V.008h-1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m15 47.996.003.002 1.326-1.325-.003-.003 6.097-6.096-1.326-1.326-5.16 5.159V0h-1.874v44.407l-5.159-5.16-1.326 1.327 6.096 6.096-.002.003 1.326 1.326.002-.003ZM26.905 8.751l5.158-5.159V48h1.875V3.592l5.158 5.16 1.327-1.327-6.097-6.096.003-.003L33.002.001 33 .003 32.998 0l-1.326 1.326.002.003-6.096 6.096 1.327 1.326Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m20 63.995.003.003 1.768-1.767-.003-.004 8.129-8.128-1.768-1.768-6.879 6.878V0h-2.5v59.209l-6.877-6.879-1.77 1.769 8.13 8.128-.004.004 1.768 1.767.003-.003Zm15.873-52.327L42.75 4.79v59.209h2.5V4.789l6.878 6.88L53.897 9.9l-8.129-8.128.004-.004-1.77-1.767L44 .004 43.997 0l-1.768 1.768.003.004L34.104 9.9l1.769 1.768Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconSorting = function IconSorting(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Sorting' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Sorting"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconSorting.sizes = [16, 24, 32, 48, 64];
IconSorting.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconSorting;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Sorting.js
// module id = 1863
// module chunks = 0